import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import Icon from "../Icon/Icon";
import { Icons } from "../../../utils/viewUtility";
import UserProfile from "../UserProfile/UserProfile";
import AppMenu from "../AppMenu/AppMenu";
import AuthService from "../../../utils/authService";
import { MenuInterface } from "../../../types";
import useStyles from "@hooks/useStyle";

const GlobalHeader = (props: { menu: MenuInterface[] }) => {
	const { classes } = useStyles() as any;
	const { menu } = props;

	return (
		<Grid container>
			<Grid item>
				<Toolbar className={classes.webLogo}>
					<Icon className={classes.brandLogo} pwaIcon iconType={Icons.HOME_LOGO} />
				</Toolbar>
			</Grid>
			<Grid item flex="1" display="flex" alignItems="center">
				{AuthService.isAuthenticated() && <AppMenu menu={menu} />}
			</Grid>
			<Grid item alignItems="center" display="flex">
				{AuthService.isAuthenticated() && <UserProfile />}
			</Grid>
		</Grid>
	);
};

export default GlobalHeader;
